import { axiosInstance } from "../../axios";
import { useQuery } from "@tanstack/react-query";
import { PaginatedResponseWithTotal, Company } from "@/common/types";
import { companyType } from "@/common/const/types/index.const";

const getVendorByName = async (searchQ: string) => {
  const params = new URLSearchParams();
  const vendorType = companyType[1];
  const searchFields = "companyName";
  const skip = 0;
  const take = 30;
  params.append("filters[companyType]", vendorType);
  params.append("searchFields", searchFields);
  params.append("skip", skip.toString());
  params.append("take", take.toString());
  params.append("searchQ", searchQ);
  return await axiosInstance
    .get("company/all", { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetVendorByName = (searchQ: string) => {
  return useQuery<PaginatedResponseWithTotal<Company>>({
    queryKey: ["vendors", searchQ],
    queryFn: () => getVendorByName(searchQ),
    enabled: !!searchQ,
  });
};

export default useGetVendorByName;
